import React from 'react';
import { DashboardTile } from './DashboardTile';
import CustomLink from '../common/CustomLink';
import MiniSpinner from "../common/MiniSpinner";

const DashboardTileLoader = ({ linkProps, tileclass, tilename }) => {

    return (
        <DashboardTile
            className={"dashboard-tile-loading-container " + tileclass}
            title={tilename}
        >
        <div className="col-12 align-self-center">
            <MiniSpinner />
        </div>
        {linkProps && <CustomLink linkProps={{ ...linkProps }}><span /></CustomLink>}
    </DashboardTile>
    );
}

DashboardTileLoader.defaultProps = {
    tileclass: "",
    tilename: "",
};

export default DashboardTileLoader;
